import { useContext } from "react";

import CoralCommentsContext, {
  type CoralService,
} from "./coral-comments-context";
import CycloneCommentsContext, {
  type CycloneService,
} from "./cyclone-comments-context";

export type CommentCountsContextValue = CoralService | CycloneService;

/**
 * Whether Cyclone is the mounted comment provider (vs Coral or noop).
 * Prefer this over reading commentsConfig.provider — reflects the actual provider tree.
 */
export function useIsCycloneCommentsProvider(): boolean {
  return useContext(CycloneCommentsContext) !== null;
}

/**
 * Returns the active comment-counts service (Cyclone or Coral).
 * Use in shared UI; prefer useCoralCommentsContext / useCycloneCommentsContext
 * when you know which provider is mounted.
 */
export function useCommentCountsContext(): CommentCountsContextValue {
  const coralContext = useContext(CoralCommentsContext);
  const cycloneContext = useContext(CycloneCommentsContext);
  const context = cycloneContext ?? coralContext;

  if (!context) {
    throw new Error(
      "useCommentCountsContext must be used within CommentProvider",
    );
  }

  return context;
}
